import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52e11e80&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=52e11e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e11e80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e11e80')) {
      api.createRecord('52e11e80', component.options)
    } else {
      api.reload('52e11e80', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=52e11e80&scoped=true&", function () {
      api.rerender('52e11e80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/base-radio-group/index.vue"
export default component.exports